import { createAsyncLocalStorage } from './async-local-storage';
export const dynamicAccessAsyncStorageInstance = createAsyncLocalStorage();

//# sourceMappingURL=dynamic-access-async-storage-instance.js.map